<template>
  <div class="">
    <b-button
      v-b-toggle.establishmentYearSettings
      class="btn btn-lg btn-collapse"
    >
      {{ $t("establishmentYearSettings") }}
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </b-button>
    <b-collapse id="establishmentYearSettings">
      <div class="my-card">
        <div class="row">
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="establishmentYearSettingView"
              v-model="
                usersPrivilegeEstablishmentYearSetting.establishmentYearSettingView
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="establishmentYearSettingView">{{
              $t("view")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="establishmentYearSettingAdd"
              v-model="
                usersPrivilegeEstablishmentYearSetting.establishmentYearSettingAdd
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="establishmentYearSettingAdd">{{
              $t("add")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="establishmentYearSettingUpdate"
              v-model="
                usersPrivilegeEstablishmentYearSetting.establishmentYearSettingUpdate
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="establishmentYearSettingUpdate">{{
              $t("edit")
            }}</label>
          </div>

          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="establishmentYearSettingArchive"
              v-model="
                usersPrivilegeEstablishmentYearSetting.establishmentYearSettingArchive
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="establishmentYearSettingArchive">{{
              $t("archive")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="establishmentYearSettingDelete"
              v-model="
                usersPrivilegeEstablishmentYearSetting.establishmentYearSettingDelete
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="establishmentYearSettingDelete">{{
              $t("finalDelete")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="establishmentYearSettingRestore"
              v-model="
                usersPrivilegeEstablishmentYearSetting.establishmentYearSettingRestore
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="establishmentYearSettingRestore">{{
              $t("restore")
            }}</label>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "UsersPrivilegeEstablishmentYearSetting",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["usersPrivilegeEstablishmentYearSetting"],
  methods: {},
};
</script>

<style scoped lang="scss"></style>
